import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { BaseRequestService } from 'app/_services/base.service';
import { CommonService } from 'app/_services/common.services';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM',
  },
  display: {
    dateInput: 'YYYY-MM',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-dsr-report',
  templateUrl: './dsr-report.component.html',
  styleUrls: ['./dsr-report.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DsrReportComponent implements OnInit {
  date = new FormControl(moment());
  product_code: any = ''
  product: any = [];
  @Input() rocode: any;
  @Input() roname: any;
  @Input() hidego: boolean = false;
  monthData: any = {}
  data: any = [];
  totalDecantedMonth: number = 0;
  tableColumnCount: number = 0;
  producthash: any = {}
  constructor(private api: BaseRequestService, public cs: CommonService) {

  }


  ngOnInit(): void {
    this.getproduct()
  }

  getproduct() {
    // product
    let q = { skip: 0, limit: 30 }
    this.api.doRequest(`/api/product_master`, 'get', null, q).subscribe((result: any) => {
      if (result && result.data && result.data.length > 0) {
        this.product = [];
        result.data.forEach(prod => {
          this.product.push({
            id: prod._id,
            product_code: prod.product_code,
            product_name: prod.product_name
          })
          this.producthash[prod.product_code] = {
            id: prod._id,
            product_code: prod.product_code,
            product_name: prod.product_name
          }
        })
        this.cs.producthash = this.producthash
        this.product_code = this.product[0].product_code
        
      }
      this.fetchRecord()
    })
  }

  fetchRecord() {
    try {
      var request =
      {
        "ro_code": this.rocode,
        "product": this.product_code,
        "month": this.date.value.format('yyyy-MM')
      }
      const productName = this.producthash[this.product_code]?.product_name || 'Unknown Product';

      const formattedStartDate = moment(this.date.value).utcOffset(240).format('MMM-yyyy'); 
      // this.cs.setStartDate(formattedStartDate);
      this.cs.setProduct(productName)
      this.cs.setStartDSR(formattedStartDate);
      localStorage.setItem("dsr_request", JSON.stringify(request))
      this.api.doRequest('/api/dutransaction/dsm_reports', 'post', request).subscribe(data => {
        if (data) {
          this.data = data
          this.formdata()
        }
      }, error => {
        console.log("error", error)
      })
    }
    catch {
      console.log("error")
    }

  }

  formdata() {
    this.monthData = this.data[0]
    this.data.forEach((day, j) => {
      day.total_tank_sales = 0;
      day.volume_decanted = 0;
      day.tanks.forEach((tan, i) => {
        if (j < this.data.length - 1) {
          const nexttank = this.data[j + 1].tanks.filter(x => x.tank == tan.tank)
          tan.end_product_volume = nexttank[0].start_product_volume
        }
        tan.total_sales = tan.total_Start - tan.end_product_volume
        day.total_tank_sales = day.total_tank_sales + tan.total_sales
        day.volume_decanted += tan.decant_volume
      })
      day.cumulative_totalizer = 0;
      day.cumulative_sales = 0;
    })
    this.data.forEach((day, j) => {
      day.nozzles.forEach(noz => {
        noz.total_totalizer = noz.next_start_totalizer_volume - noz.start_totalizer_volume
        day.cumulative_totalizer += noz.total_totalizer
        day.testing_totalizer += noz.test_sales
        day.cumulative_sales += noz.total_sales
      })


      // Add the previous day's cumulative_totalizer_month to today's cumulative_totalizer
      if (j > 0) {
        day.cumulative_totalizer_month = this.data[j - 1].cumulative_totalizer_month + day.cumulative_totalizer;
      } else {
        // For the first day, it is just the cumulative totalizer
        day.cumulative_totalizer_month = day.cumulative_totalizer;
      }

      // Running sum of decanted volume for the month
      if (j > 0) {
        day.cumulative_decanted_month = (this.data[j - 1].cumulative_decanted_month || 0) + (day.volume_decanted || 0);
      } else {
        day.cumulative_decanted_month = day.volume_decanted || 0;
      }
      day.profit_totalizer_d = day.cumulative_totalizer - day.testing_totalizer
      day.profit_sales_f = day.cumulative_sales - day.testing_totalizer
      day.d_minus_f = day.profit_totalizer_d - day.profit_sales_f
      day.gain_per_totalizer = day.profit_totalizer_d - day.total_tank_sales
      day.gain_per_transaction = day.profit_sales_f - day.total_tank_sales
      day.cumulative_gain_per_totalizer = day.cumulative_totalizer - day.total_tank_sales
      day.cumulative_gain_per_transaction = day.cumulative_sales - day.total_tank_sales
    })

    this.totalDecantedMonth = this.data.reduce((sum, day) => sum + (Number(day?.volume_decanted) || 0), 0);
    this.tableColumnCount = 10 + (this.monthData?.tanks?.length || 0) + (this.monthData?.nozzles?.length || 0);
  }


  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }


}
